import UnregisteredRoute from './UnregisterRoute';

export default UnregisteredRoute;
